"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
const ThemeDiv = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  --primary: ", ";\n  --accent: ", ";\n\n  --black: ", ";\n  --white: ", ";\n\n  --error: ", ";\n\n  --font: ", ";\n"])), props => props.theme.primary, props => props.theme.accent, props => props.theme.black, props => props.theme.white, props => props.theme.error, props => props.theme.font);
var _default = exports.default = ThemeDiv;